import React, { useState, useEffect } from "react";
import Breadcrumb from "../Component/Breadcrumb";
import { getPrincipalMessage } from "../Service/Api";
function Principal() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    document.title = "Principal's Message";
    const fetchData = async () => {
      try {
        const response = await getPrincipalMessage();

        const result = Array.isArray(response)
          ? response
          : Array.isArray(response?.data)
            ? response.data
            : response
              ? [response]
              : [];

        setData(result);
      } catch (error) {
        console.error("Principal Message API Error:", error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const principal = data[0];

  const defaultImage =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/profilethumb.png";

  const imageUrl = principal?.attachments
    ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${principal.attachments}`
    : defaultImage;

  return (
    <>
      <Breadcrumb>Principal's Message</Breadcrumb>
      <section className="principal-section">
        <div className="container">
          <div className="principal-heading">
            <h1>Principal's Message</h1>
            <span className="principal-heading-line"></span>
            {/* <p>Inspiring young minds to learn, grow, and achieve excellence.</p> */}
          </div>
          {loading ? (
            <div className="principal-status">
              <div className="principal-loader"></div>
              <p>Loading Principal's Message...</p>
            </div>
          ) : principal ? (
            <div className="principal-card">
              <div className="principal-profile">
                <div className="principal-image-frame">
                  <img
                    src={imageUrl}
                    alt={principal.name || "School Principal"}
                    className="principal-image"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = defaultImage;
                    }}
                  />
                </div>
                <div className="principal-profile-info">
                  <span className="principal-profile-label">
                    A MESSAGE FROM
                  </span>
                  <h2>{principal.name || "Principal"}</h2>
                  <p>{principal.category || "Principal"}</p>
                  <span className="principal-profile-divider"></span>
                </div>
              </div>
              <div className="principal-message">
                <span className="principal-quote-mark">“</span>
                {principal.message ? (
                  <div
                    className="principal-message-content"
                    dangerouslySetInnerHTML={{
                      __html: principal.message,
                    }}
                  />
                ) : (
                  <p>The principal's message will be available soon.</p>
                )}
              </div>
            </div>
          ) : (
            <div className="principal-status">
              <h3>Message Unavailable</h3>
              <p>
                We are unable to load the Principal's Message at the moment.
                Please try again later.
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}

export default Principal;
